const mediaItems = [
  {
    id: 1,
    title: '深度揭秘：网红直播带货的十大套路',
    duration: '15:28',
    views: '28.6万',
    image: 'https://readdy.ai/api/search-image?query=A%20dramatic%20video%20thumbnail%20style%20image%20of%20a%20dark%20live%20streaming%20studio%20setup%20with%20ring%20light%20and%20products%20displayed%2C%20play%20button%20overlay%20suggestion%2C%20moody%20atmosphere%2C%20warm%20crimson%20and%20dark%20tones%2C%20editorial%20video%20thumbnail%20aesthetic&width=800&height=450&seq=media-01-hl&orientation=landscape',
  },
  {
    id: 2,
    title: '吃瓜现场：某选秀导师被当面对质的尴尬瞬间',
    duration: '08:42',
    views: '35.1万',
    image: 'https://readdy.ai/api/search-image?query=A%20tense%20confrontation%20scene%20on%20a%20dark%20TV%20studio%20stage%2C%20spotlight%20on%20empty%20chairs%2C%20dramatic%20theatrical%20lighting%2C%20video%20thumbnail%20style%2C%20moody%20atmosphere%2C%20editorial%20aesthetic%2C%20warm%20dark%20tones&width=800&height=450&seq=media-02-hl&orientation=landscape',
  },
  {
    id: 3,
    title: '全网最全：2026上半年网红翻车事件大盘点',
    duration: '22:15',
    views: '42.3万',
    image: 'https://readdy.ai/api/search-image?query=A%20collage%20style%20video%20thumbnail%20with%20multiple%20dark%20dramatic%20news%20headlines%2C%20broken%20screens%2C%20scattered%20newspaper%20clippings%2C%20moody%20atmosphere%2C%20warm%20crimson%20and%20amber%20tones%2C%20editorial%20video%20thumbnail%20aesthetic&width=800&height=450&seq=media-03-hl&orientation=landscape',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-5xl mx-auto">
          <div className="flex items-center gap-3 mb-8">
            <span className="w-1 h-6 bg-accent-500 rounded-full"></span>
            <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950">
              视频吃瓜
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
            {mediaItems.map((item) => (
              <div
                key={item.id}
                className="bg-background-100 rounded-lg overflow-hidden border border-background-200/60 hover:border-primary-200 transition-colors cursor-pointer group"
              >
                <div className="relative w-full aspect-video overflow-hidden bg-background-200">
                  <img
                    src={item.image}
                    alt={item.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    loading="lazy"
                  />
                  {/* Play button overlay */}
                  <div className="absolute inset-0 flex items-center justify-center">
                    <div className="w-12 h-12 flex items-center justify-center rounded-full bg-background-950/70 text-background-50 group-hover:bg-primary-500 transition-colors">
                      <i className="ri-play-fill text-lg ml-0.5"></i>
                    </div>
                  </div>
                  {/* Duration badge */}
                  <span className="absolute bottom-2 right-2 text-[10px] bg-background-950/80 text-background-50 px-1.5 py-0.5 rounded whitespace-nowrap">
                    {item.duration}
                  </span>
                </div>
                <div className="p-4">
                  <h3 className="text-sm font-bold text-foreground-950 leading-snug line-clamp-2 group-hover:text-primary-600 transition-colors">
                    {item.title}
                  </h3>
                  <div className="mt-2 flex items-center gap-1 text-[11px] text-foreground-400">
                    <i className="ri-eye-line"></i>
                    <span>{item.views} 次观看</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}